/* ================================================================ */
// SIDEBAR CONTAINER | Sidebar.jsx
/* ================================================================ */
/* ========================================== */
// Imports
/* ========================================== */
import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

//import 'url-search-params-polyfill';
// Hooks
import useReactRouter from 'use-react-router';
// Material UI
import makeStyles from '@material-ui/styles/makeStyles';

import './gridUtils.js';
import { WidthProvider, Responsive } from "react-grid-layout";
const ResponsiveReactGridLayout = WidthProvider(Responsive);
import IconManager from './IconManager';

import 'react-resizable/css/styles.css';
import 'react-grid-layout/css/styles.css';

const useStyles = makeStyles(() => ({
    root: {
        position:'absolute',
        top:'10px',
        left:'10px',
        height:'720px',
        width:'1280px',
        border:'1px solid black',
        background:'#fff',
        zIndex:'2',
    }
}));

const Spritesheet = (props) => {
  const classes = useStyles();
  const imageUploader = React.useRef(null);

  const [items, setItems] = useState([]);
  const [elements, setElements] = useState(null);
  const [newCounter, setCounter] = useState(items.length);
  const [resolution, setResolution] = useState(32);

  const iconManager = new IconManager({onUpdate: () => _onUpdate()});//, {onUpdate: () => this._onUpdate()})

  function _onUpdate() {
    //console.log("update");
  }

  useEffect(() => {
    setElements(_.map(items, el => createElement(el)));
  },[items]);

  const handleImageUpload = e => {
    const [file] = e.target.files;
    if (file) {
      const reader = new FileReader();
      
      reader.onload = e => {
        var image = new Image();
        image.src = e.target.result;
        image.onload = function() {
          onAddItem(this);
        };
        
      };
      reader.readAsDataURL(file);
    }
    e.target.value = null;
  };

  let cols = { lg: (1282/resolution) }

  const createElement = (el) => {
    const removeStyle = {
      position: "absolute",
      right: "2px",
      top: 0,
      cursor: "pointer"
    };
    const i = el.i;
    return (
      <div key={i} data-grid={el}>
        {<img src={el.src} style={{width: el.w*resolution, height: el.h*resolution}}/>}
        <span
          className="remove"
          style={removeStyle}
          onClick={onRemoveItem.bind(this,i)}
        >
          x
        </span>
      </div>
    );
  }
  function onRemoveItem (i) {
    setItems(items => items.filter( (item) => item.i != i));
  }

  function onAddItem(image) {
    /*eslint no-console: 0*/
    console.log("adding", "n" + newCounter);
    // Add a new item. It must have a unique key!
    setItems(items => [...items, { 
        i: "n" + newCounter,
        id: "n" + newCounter,
        x: 0,//(items.length * 2) % (cols.lg || 12),
        y: 0, // puts it at the bottom
        w: (image.width/resolution),
        h: (image.height/resolution),
        src: image.src,
        image: image,
        resolution: resolution
      }])
    // Increment the counter to ensure key is always unique.
    setCounter(newCounter => newCounter + 1)
  }

  function onItemResize(e) {
    setItems(items => items.map( (item,idx) => {
      e[idx].src = item.src;
      item.image.width = e[idx].w * resolution;
      item.image.height = e[idx].h * resolution;
      e[idx].image = item.image;
      e[idx].id = item.id;
      e[idx].resolution = item.resolution;
      return e[idx];
    }));
  }

  const onLayoutChange = (e) => {
    setItems(items => items.map( (item,idx) => {
      e[idx].src = item.src;
      item.image.width = e[idx].w * resolution;
      item.image.height = e[idx].h * resolution;
      e[idx].image = item.image;
      e[idx].id = item.id;
      e[idx].resolution = item.resolution;
      e[idx].x = e[idx].x < 0 ? 0 : e[idx].x;
      e[idx].y = e[idx].y < 0 ? 0 : e[idx].y;
      return e[idx];
    }));
  }

  const onBreakpointChange = (breakpoint, cols) => {
    breakpoint = breakpoint;
    cols = cols;
  }

  const handleAtlasCreation = () => {
    iconManager._updateAutoPacking(items);
  }

  return (
    
    <div className={classes.root}>
      {/* <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
      }}
    >*/}
      {<div>
        <input
        type="file"
        accept="image/*"
        onChange={handleImageUpload}
        ref={imageUploader}
        
      />
      <button onClick={handleAtlasCreation}>Create Atlas</button>
        <ResponsiveReactGridLayout
          verticalCompact={true}
          compactType={'horizontal'}
          measureBeforeMount={true}
          margin={[0,0]}
          cols={cols}
          onLayoutChange={onLayoutChange}
          onBreakpointChange={onBreakpointChange}
          onResizeStop={onItemResize}
          onDragStop={onItemResize}
          className={"layout"}
          rowHeight={resolution}
        >
          {elements}
        </ResponsiveReactGridLayout>
      </div>}
      </div>
    );
};

export default Spritesheet;
/*
[0, 1, 2, 3, 4].map(function(i, key, list) {
    return {
        i: i.toString(),
        x: i * 2,
        y: 0,
        w: 2,
        h: 2,
        src: 'https://www.fixyourbrowser.com/wp-content/uploads/2019/08/Android-Logo.png'
    };*/